import { _UserCreateModel } from "../interfaces/requestCreateModels/_UserCreateModel";

export class UserCreateModel extends _UserCreateModel{
    // name:string;
    // email:string;
    // permissions:number;
    // userIcon?:string;
    // role?:string;
}